export enum analyticsEvents {
  PAGE_VIEWED = "page_viewed",
  BUTTON_CLICKED = "button_clicked",
  LOG_IN = "log_in"
}

// Vitable Event Payloads
export type PageViewedProperties = {
  name: string | null | undefined
  path: string
  from_name: string | null | undefined
  from_path: string | null
}

export type ButtonClickedProperties = {
  page_name: string
  cta_text: string
  button_id?: Optional<string>
}

// App Specific Event Payloads
